import { debounce as lodashDebounce, DebounceSettings } from 'lodash';

export default function Debounce(wait?: number, options?: DebounceSettings) {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalFunction = descriptor.value as () => any;
        descriptor.value = lodashDebounce(originalFunction, wait, options);
    };
}
